exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2UxKMNua2KSiL6{padding-top:8px;padding-right:8px;margin-bottom:0;color:#172b4d}._3fzsq9jEZYVCax{margin-left:24px}._3i3aIPvVcGa13r{position:absolute;left:-10px;top:10px;font-size:30px}.yXN9qZ4e4tA7WG{margin-top:0}", ""]);

// exports
exports.locals = {
	"bcPromptHeader": "_2UxKMNua2KSiL6",
	"settingItem": "_3fzsq9jEZYVCax",
	"bcPromptSparkle": "_3i3aIPvVcGa13r",
	"bcPromptUpgrade": "yXN9qZ4e4tA7WG"
};